import { createGlobalStyle } from 'styled-components'
import fonts from './fonts'
import variables from './variables'

const GlobalStyle = createGlobalStyle`
  ${fonts};
  ${variables};

  *,
  ::before,
  ::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    border-width: 0;
  }

  ::selection {
    color: var(--white);
    background-color: rgba(248, 209, 112, 0.6);
  }

  :focus-visible {
    outline: 0.2rem solid rgba(248, 209, 112, 1);
    outline-offset: 2px;
  }

  html {
    width: 100%;
    scroll-behavior: smooth;
    text-size-adjust: 100%;
    background-color: var(--black);
  }

  body {
    width: 100%;
    min-height: 100%;
    margin: 0;
    overflow-x: hidden;
    color: var(--white);
    font-family: var(--font-condensed);
    font-size: var(--fz-md);
    font-weight: 400;
    font-style: normal;
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    background-color: var(--black);
    &.hidden {
      overflow: hidden;
    }
    &.blur {
      overflow: hidden;
      header {
        backdrop-filter: none;
        box-shadow: none;
      }
      #content > * {
        filter: blur(5px) brightness(0.7);
        transition: var(--transition);
        pointer-events: none;
        user-select: none;
      }
    }
  }

  img {
    display: block;
    max-width: 100%;
  }

  a {
    color: inherit;
    text-decoration: none;
    background-color: transparent;
    transition: var(--transition);
    &:link,
    &:visited {
      color: var(--white);
    }
    &:hover {
      color: var(--grey-medium);
    }
  }

  a.secondary-link {
    position: relative;
    &:link,
    &:visited {
      color: var(--secondary);
      font-weight: 500;
    }
    &:hover {
      color: var(--grey-medium);
      transform: translateY(-12px);
    }
  }

  p {
    margin: 0;
    line-height: 1.42;
  }

  h1 {
    color: var(--title);
    font-family: var(--font-sans);
    font-size: var(--fz-xxl);
    font-weight: 600;
    line-height: 1.5;
  }

  h2 {
    color: var(--title);
    font-family: var(--font-sans);
    font-size: var(--fz-xl);
    font-weight: 600;
    line-height: 1.25;
  }

  h3 {
    color: var(--title);
    font-family: var(--font-condensed);
    font-size: var(--fz-lg);
    font-weight: 600;
    line-height: 1.25;
  }

  h4 {
    color: var(--title);
    font-family: var(--font-condensed);
    font-size: var(--fz-md);
    font-weight: 600;
    line-height: 1.42;
  }

  h5 {
    font-family: var(--font-condensed);
    font-size: var(--fz-md);
    font-weight: 400;
    text-transform: uppercase;
  }

  h6 {
    color: var(--title);
    font-family: var(--font-condensed);
    font-size: var(--fz-sm);
    font-weight: 400;
    text-transform: uppercase;
  }

  input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  .start-opacity {
    opacity: 0;
  }

  .end-opacity {
    opacity: 1;
  }

  .button {
    display: inline-block;
    cursor: pointer;
    width: auto;
    padding: 14px 28px 17px;
    text-align: center;
    color: var(--white);
    font-family: var(--font-condensed);
    font-size: var(--fz-lg);
    font-weight: 500;
    line-height: 1;
    border-radius: 4px;
    transition: var(--transition);
    background-color: var(--secondary);
    box-shadow: 0 0 20px 0 rgb(0 0 0 / 10%);
    &:hover {
      color: var(--white);
      background-color: var(--grey-hover);
    }
  }

  .button.disabled {
    cursor: not-allowed;
    pointer-events: none;
    background-color: var(--grey-hover);
  }

  input[type='file']::file-selector-button {
    display: inline-block;
    cursor: pointer;
    width: auto;
    padding: 11px 16px 13px;
    margin-right: 12px;
    text-align: center;
    color: var(--white);
    font-family: var(--font-condensed);
    font-size: var(--fz-md);
    font-weight: 500;
    line-height: 1;
    border-radius: 4px;
    transition: var(--transition);
    border: none;
    background-color: var(--secondary);
    -webkit-appearance: none;
    &:hover {
      color: var(--white);
      background-color: var(--grey-hover);
    }
  }

  .mb-15 {
    margin-bottom: 15px;
  }
  
  .mb-20 {
    margin-bottom: 20px;
  }

`

export default GlobalStyle
